import axiosApiClient from '..';
import { handleError } from '../../utils/errors';

const BASE_URL = '/common';

class CommonService {
  getAllVendorFaQ = async page => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/vendor/faq?page=${page}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching all faq.');
    }
  };

  getVendorFaQForUser = async id => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/faq/vendor/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching vendor faq for user.');
    }
  };

  createVendorFaQ = async ({ question, answer }) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/vendor/faq`, { question, answer });
      if (response.status !== 201) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while creating vendor faq.');
    }
  };

  updateVendorFaQ = async ({ question, answer, id }) => {
    try {
      const response = await axiosApiClient.put(`${BASE_URL}/vendor/faq/${id}`, { question, answer });
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while updating vendor faq.');
    }
  };

  deleteVendorFaQ = async id => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/vendor/faq/${id}`);
      if (response.status !== 200) {
        throw new Error();
      }

      return response.data;
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting vendor faq.');
    }
  };
}
const commonService = new CommonService();

export default commonService;
